export const getInitialsFromEmail = (email) => {
    const name = email.split("@");
    return name[0];
  };
  